<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5781 6.06641L8.00084 3.48912L5.42355 6.06641" stroke="currentColor" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.5781 9.93359L8.00084 12.5109L5.42355 9.93359" stroke="currentColor" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
